import type { MapSettingsDataAction } from '../data/mapSettingsData.action';
import { MAP_SETTINGS_REMOVE_ACTIVE_ITEMS } from '../data/mapSettingsData.actionTypes';
import type { MapSettingsPlacesAction } from './mapSettingsPlaces.action';
import {
  mapSettingsPlacesAddSearch, mapSettingsPlacesRemovePlaceFromSearch, mapSettingsPlacesRemoveSearch,
} from './mapSettingsPlaces.actionCreators';
import type { MapSettingsPlacesState } from './mapSettingsPlaces.state';

export const mapSettingsPlacesInitialState: MapSettingsPlacesState = {
  searches: [],
};

export const mapSettingsPlacesReducer = (
  state = mapSettingsPlacesInitialState,
  action: MapSettingsPlacesAction | MapSettingsDataAction
): MapSettingsPlacesState => {
  if (mapSettingsPlacesAddSearch.match(action)) {
    return {
      ...state,
      searches: [...state.searches, action.payload.newSearch],
    };
  }

  if (mapSettingsPlacesRemoveSearch.match(action)) {
    return {
      ...state,
      searches: state.searches.filter((search) => action.payload.search.id !== search.id),
    };
  }

  if (mapSettingsPlacesRemovePlaceFromSearch.match(action)) {
    const { searchId, placeId } = action.payload;
    return {
      ...state,
      searches: state.searches.map((search) => {
        if (search.id === searchId) {
          return {
            ...search,
            removedPlaces: [...(search.removedPlaces ?? []), placeId],
          };
        }
        return search;
      }),
    };
  }

  switch (action.type) {
    case MAP_SETTINGS_REMOVE_ACTIVE_ITEMS: {
      return {
        ...state,
        searches: [],
      };
    }
    default:
      return state;
  }
};
